// import { useEffect, useState, useRef, useCallback } from "react";
// import { useRouter } from "next/router";

// // ── Config ────────────────────────────────────────────────────────────────────
// const PUBLIC_ROUTES = ["/", "/"];
// const INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 minutes → auto logout
// const WARNING_BEFORE = 1 * 60 * 1000; // show warning 1 minute before logout
// const SESSION_KEY = "session_active"; // sessionStorage flag

// const ProtectedRoute = ({ children }) => {
//   const router = useRouter();
//   const [authChecked, setAuthChecked] = useState(false);
//   const [showWarning, setShowWarning] = useState(false);
//   const [countdown, setCountdown] = useState(60); // seconds shown in warning

//   const logoutTimerRef = useRef(null);
//   const warningTimerRef = useRef(null);
//   const countdownInterval = useRef(null);

//   // ── Logout: wipe all auth data and go to login ──────────────────────────
//   const logout = useCallback(
//     (reason = "") => {
//       clearTimeout(logoutTimerRef.current);
//       clearTimeout(warningTimerRef.current);
//       clearInterval(countdownInterval.current);

//       // Remove every key your login page saves
//       localStorage.removeItem("token");
//       localStorage.removeItem("userId");
//       localStorage.removeItem("clientId");
//       localStorage.removeItem("roles");
//       sessionStorage.removeItem(SESSION_KEY);

//       if (reason) console.warn("Auto-logout reason:", reason);
//       router.replace("/login");
//     },
//     [router],
//   );

//   // ── Reset inactivity timers on any user activity ─────────────────────────
//   const resetTimer = useCallback(() => {
//     clearTimeout(logoutTimerRef.current);
//     clearTimeout(warningTimerRef.current);
//     clearInterval(countdownInterval.current);
//     setShowWarning(false);
//     setCountdown(60);

//     // Show warning at 14 minutes
//     warningTimerRef.current = setTimeout(() => {
//       setShowWarning(true);
//       setCountdown(60);

//       // Countdown every second inside the warning banner
//       countdownInterval.current = setInterval(() => {
//         setCountdown((prev) => {
//           if (prev <= 1) {
//             clearInterval(countdownInterval.current);
//             return 0;
//           }
//           return prev - 1;
//         });
//       }, 1000);
//     }, INACTIVITY_TIMEOUT - WARNING_BEFORE);

//     // Auto logout at 15 minutes
//     logoutTimerRef.current = setTimeout(() => {
//       logout("15 minutes of inactivity");
//     }, INACTIVITY_TIMEOUT);
//   }, [logout]);

//   // ── Auth check on every route change ─────────────────────────────────────
//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const sessionActive = sessionStorage.getItem(SESSION_KEY);
//     const isPublicRoute = PUBLIC_ROUTES.includes(router.pathname);

//     if (!token && !isPublicRoute) {
//       // No token → not logged in → redirect to login
//       router.replace("/login");
//       return;
//     }

//     if (token && isPublicRoute) {
//       // Already logged in → don't show login page again
//       router.replace("/getallclientusers");
//       return;
//     }

//     if (token && !sessionActive && !isPublicRoute) {
//       // Token exists in localStorage BUT sessionStorage flag is gone
//       // → Browser was closed without logging out → treat as new session → logout
//       logout("browser closed without logout — new session detected");
//       return;
//     }

//     // ✅ All checks passed — allow the page to render
//     setAuthChecked(true);

//     if (!isPublicRoute) {
//       resetTimer(); // start inactivity countdown
//     }

//     return () => {
//       clearTimeout(logoutTimerRef.current);
//       clearTimeout(warningTimerRef.current);
//       clearInterval(countdownInterval.current);
//     };
//   }, [router.pathname]);

//   // ── Listen for user activity on protected pages ───────────────────────────
//   useEffect(() => {
//     const isPublicRoute = PUBLIC_ROUTES.includes(router.pathname);
//     if (isPublicRoute || !authChecked) return;

//     const EVENTS = [
//       "mousedown",
//       "mousemove",
//       "keydown",
//       "scroll",
//       "touchstart",
//       "click",
//     ];
//     const handleActivity = () => {
//       setShowWarning(false); // hide warning if user becomes active
//       resetTimer();
//     };

//     EVENTS.forEach((e) =>
//       window.addEventListener(e, handleActivity, { passive: true }),
//     );

//     return () => {
//       EVENTS.forEach((e) => window.removeEventListener(e, handleActivity));
//     };
//   }, [router.pathname, authChecked, resetTimer]);

//   // ── Loading screen while auth check is running ────────────────────────────
//   if (!authChecked && !PUBLIC_ROUTES.includes(router.pathname)) {
//     return (
//       <div style={styles.loadingWrapper}>
//         <div style={styles.spinner} />
//         <p style={styles.loadingText}>Checking authentication...</p>
//         <style>{spinKeyframe}</style>
//       </div>
//     );
//   }

//   return (
//     <>
//       {/* ── Inactivity Warning Banner ── */}
//       {showWarning && (
//         <div style={styles.warningBanner}>
//           {/* <span style={styles.warningIcon}>⚠️</span>
//           <span style={styles.warningText}>
//             You will be logged out due to inactivity in{" "}
//             <strong>
//               {countdown} second{countdown !== 1 ? "s" : ""}
//             </strong>
//           </span> */}
//           <button
//             style={styles.stayButton}
//             onClick={() => {
//               setShowWarning(false);
//               resetTimer();
//             }}
//           >
            
//           </button>
//         </div>
//       )}

//       {children}
//     </>
//   );
// };

// // ── Styles ────────────────────────────────────────────────────────────────────
// const spinKeyframe = `
//   @keyframes spin {
//     from { transform: rotate(0deg); }
//     to   { transform: rotate(360deg); }
//   }
// `;

// const styles = {
//   loadingWrapper: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     height: "100vh",
//     flexDirection: "column",
//     gap: "16px",
//   },
//   spinner: {
//     width: "40px",
//     height: "40px",
//     border: "3px solid #e5e7eb",
//     borderTop: "3px solid #4f46e5",
//     borderRadius: "50%",
//     animation: "spin 0.8s linear infinite",
//   },
//   loadingText: {
//     color: "#6b7280",
//     fontSize: "14px",
//   },
//   warningBanner: {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     right: 0,
//     zIndex: 9999,
//     backgroundColor: "#fef3c7",
//     borderBottom: "2px solid #f59e0b",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: "12px",
//     padding: "12px 24px",
//     fontSize: "14px",
//     color: "#92400e",
//     boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//   },
//   warningIcon: {
//     fontSize: "18px",
//   },
//   warningText: {
//     flex: 1,
//     textAlign: "center",
//   },
//   stayButton: {
//     backgroundColor: "#f59e0b",
//     color: "#fff",
//     border: "none",
//     borderRadius: "6px",
//     padding: "6px 16px",
//     fontSize: "13px",
//     fontWeight: "600",
//     cursor: "pointer",
//     whiteSpace: "nowrap",
//   },
// };

// export default ProtectedRoute;


import { useEffect, useState, useRef, useCallback } from "react";
import { useRouter } from "next/router";

// ── Config ────────────────────────────────────────────────────────────────────
const PUBLIC_ROUTES = ["/", "/"];
const INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 minutes → auto logout
const WARNING_BEFORE = 1 * 60 * 1000; // show warning 1 minute before logout
const SESSION_KEY = "session_active"; // sessionStorage flag

const ProtectedRoute = ({ children }) => {
  const router = useRouter();
  const [authChecked, setAuthChecked] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [countdown, setCountdown] = useState(60); // seconds shown in warning

  const logoutTimerRef = useRef(null);
  const warningTimerRef = useRef(null);
  const countdownInterval = useRef(null);

  // ── Logout: wipe all auth data and go to login ──────────────────────────
  const logout = useCallback(
    (reason = "") => {
      clearTimeout(logoutTimerRef.current);
      clearTimeout(warningTimerRef.current);
      clearInterval(countdownInterval.current);

      // Remove every key your login page saves
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("clientId");
      localStorage.removeItem("roles");
      sessionStorage.removeItem(SESSION_KEY);

      if (reason) console.warn("Auto-logout reason:", reason);
      router.replace("/");
    },
    [router],
  );

  // ── Reset inactivity timers on any user activity ─────────────────────────
  const resetTimer = useCallback(() => {
    clearTimeout(logoutTimerRef.current);
    clearTimeout(warningTimerRef.current);
    clearInterval(countdownInterval.current);
    setShowWarning(false);
    setCountdown(60);

    // Show warning at 14 minutes
    warningTimerRef.current = setTimeout(() => {
      setShowWarning(true);
      setCountdown(60);

      // Countdown every second inside the warning banner
      countdownInterval.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }, INACTIVITY_TIMEOUT - WARNING_BEFORE);

    // Auto logout at 15 minutes
    logoutTimerRef.current = setTimeout(() => {
      logout("15 minutes of inactivity");
    }, INACTIVITY_TIMEOUT);
  }, [logout]);

  // ── Auth check on every route change ─────────────────────────────────────
  useEffect(() => {
    const token = localStorage.getItem("token");
    const sessionActive = sessionStorage.getItem(SESSION_KEY);
    const isPublicRoute = PUBLIC_ROUTES.includes(router.pathname);

    if (!token && !isPublicRoute) {
      // No token → not logged in → redirect to login
      router.replace("/");
      return;
    }

    if (token && isPublicRoute) {
      // Already logged in → don't show login page again
      router.replace("/getallclientusers");
      return;
    }

    if (token && !sessionActive && !isPublicRoute) {
      // Token exists in localStorage BUT sessionStorage flag is gone
      // → Browser was closed without logging out → treat as new session → logout
      logout("browser closed without logout — new session detected");
      return;
    }

    // ✅ All checks passed — allow the page to render
    setAuthChecked(true);

    if (!isPublicRoute) {
      resetTimer(); // start inactivity countdown
    }

    return () => {
      clearTimeout(logoutTimerRef.current);
      clearTimeout(warningTimerRef.current);
      clearInterval(countdownInterval.current);
    };
  }, [router.pathname]);

  // ── Listen for user activity on protected pages ───────────────────────────
  useEffect(() => {
    const isPublicRoute = PUBLIC_ROUTES.includes(router.pathname);
    if (isPublicRoute || !authChecked) return;

    const EVENTS = [
      "mousedown",
      "mousemove",
      "keydown",
      "scroll",
      "touchstart",
      "click",
    ];
    const handleActivity = () => {
      setShowWarning(false); // hide warning if user becomes active
      resetTimer();
    };

    EVENTS.forEach((e) =>
      window.addEventListener(e, handleActivity, { passive: true }),
    );

    return () => {
      EVENTS.forEach((e) => window.removeEventListener(e, handleActivity));
    };
  }, [router.pathname, authChecked, resetTimer]);

  // ── Loading screen while auth check is running ────────────────────────────
  if (!authChecked && !PUBLIC_ROUTES.includes(router.pathname)) {
    return (
      <div style={styles.loadingWrapper}>
        <div style={styles.spinner} />
        <p style={styles.loadingText}>Checking authentication...</p>
        <style>{spinKeyframe}</style>
      </div>
    );
  }

  return (
    <>
      {/* ── Inactivity Warning Banner ── */}
      {showWarning && (
        <div style={styles.warningBanner}>
          {/* <span style={styles.warningIcon}>⚠️</span>
          <span style={styles.warningText}>
            You will be logged out due to inactivity in{" "}
            <strong>
              {countdown} second{countdown !== 1 ? "s" : ""}
            </strong>
          </span> */}
          <button
            style={styles.stayButton}
            onClick={() => {
              setShowWarning(false);
              resetTimer();
            }}
          >
            
          </button>
        </div>
      )}

      {children}
    </>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────
const spinKeyframe = `
  @keyframes spin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
`;

const styles = {
  loadingWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    flexDirection: "column",
    gap: "16px",
  },
  spinner: {
    width: "40px",
    height: "40px",
    border: "3px solid #e5e7eb",
    borderTop: "3px solid #4f46e5",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
  loadingText: {
    color: "#6b7280",
    fontSize: "14px",
  },
  warningBanner: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
    backgroundColor: "#fef3c7",
    borderBottom: "2px solid #f59e0b",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    padding: "12px 24px",
    fontSize: "14px",
    color: "#92400e",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  warningIcon: {
    fontSize: "18px",
  },
  warningText: {
    flex: 1,
    textAlign: "center",
  },
  stayButton: {
    backgroundColor: "#f59e0b",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "6px 16px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
};

export default ProtectedRoute;
